import { DateTime } from 'luxon'
import * as React from 'react'
import { getEventIcon, getEventName } from '../../helpers/eventHelper.tsx'
import { IEvent } from '../../interfaces/types.ts'
import { useSnapshot } from 'valtio'
import { controlState } from '../../store/controlState.ts'
import { authState, effectiveTimezone } from '../../store/authState.ts'

interface Props {
    event: IEvent,
    index: number
}

export const EventItem: React.FC<Props> = (props) => {
    const { event, index  } = props
    const isMobile = useSnapshot(controlState).isOnMobileDevice
    // Subscribe so component re-renders when timezone changes
    useSnapshot(authState)

    const zone = effectiveTimezone().value
    const dt = DateTime.fromISO(event.createdAt).setZone(zone)
    const dateTime = dt.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
    const name = getEventName(event)
    const icon = getEventIcon(event)

    // Relative time (matches RecentEventsPopup)
    const diff = DateTime.now().setZone(zone).diff(dt, ['hours', 'minutes'])
    const hours = Math.floor(diff.hours)
    const minutes = Math.floor(diff.minutes)
    const relativeTime = hours < 1
        ? (minutes <= 1 ? 'Just now' : `${minutes} min ago`)
        : hours < 24
            ? (hours === 1 ? '1 hour ago' : `${hours} hours ago`)
            : ''

    return (
        <div
            key={event._id}
            className={`flex items-center gap-3 px-4 py-2.5 ${index % 2 === 0 ? 'bg-base-100' : 'bg-primary/5'}`}
        >
            <div className={'shrink-0 text-primary'}>{icon}</div>
            <div className={'flex-1 min-w-0'}>
                <div className={'text-sm font-semibold text-base-content truncate'}>{name}</div>
                <div className={'text-xs text-base-content/60'}>
                    {relativeTime ? relativeTime : dateTime}
                    {!isMobile && relativeTime && (
                        <span className={'ml-2 opacity-70'}>· {dateTime}</span>
                    )}
                </div>
            </div>
        </div>
    )
}
